/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import type { ReactNode } from 'react'

import { PageTitle, useTitleInset } from '@/components/ui/page-header/AppTitleBar'

/** The blue header the geofence screens open with, as the Audit Logs page does: icon, title, subtitle, actions. */
export const GeofencePageHeader = ({
  icon,
  title,
  subtitle,
  actions,
}: {
  icon?: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
}) => {
  const titleInset = useTitleInset()
  return (
    <div
      className={`relative z-20 shrink-0 rounded-box bg-primary py-1 pr-4 ${titleInset} text-primary-content shadow-md`}
    >
      <div className="flex items-center justify-between gap-4 min-h-8">
        <div className="flex items-center gap-2 min-w-0">
          {icon && <span className="text-lg shrink-0">{icon}</span>}
          <div className="flex items-baseline gap-3 min-w-0">
            <PageTitle className="truncate">{title}</PageTitle>
            {subtitle && <p className="hidden sm:block text-sm text-primary-content/70 truncate">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </div>
  )
}
